const STEPS = [
  {
    num: "01",
    title: "Estimate Intake",
    body: "Forward the carrier's partial estimate or short-pay adjustment to review@trybrim.com — the same PDF already in your inbox. Brim parses lines across CCC ONE, Mitchell, and Audatex automatically.",
    effort: "~30 seconds",
  },
  {
    num: "02",
    title: "Precedent Citation",
    body: "The agent pulls the exact P-page section, DEG inquiry, or vehicle manufacturer position statement supporting the procedure — then drafts every response and queues each follow-up on the carrier's own clock.",
    effort: "One tap per round",
  },
  {
    num: "03",
    title: "Shop-Branded Output",
    body: "Review the drafted letter on your phone, click approve, and the carrier receives a formal shop dispute signed by your estimator. Payment is reconciled against your repair order.",
    effort: "Reading one email",
  },
];

const HowItWorks = () => (
  <section
    id="how-it-works"
    data-testid="how-it-works-section"
    className="py-20 sm:py-28 bg-white border-b border-[#E7E5E4]"
  >
    <div className="max-w-4xl mx-auto px-4 sm:px-6">
      <div className="mb-12">
        <span className="text-xs font-bold uppercase tracking-widest text-[#9A3412]">
          The Brim System
        </span>
        <h2 className="text-3xl sm:text-4xl font-normal text-stone-900 font-serif-display mt-2">
          A quiet background engine for your estimating office.
        </h2>
        <p className="text-sm text-stone-600 mt-3 max-w-xl">
          Agents do the research and the writing. You read it and approve it. It
          goes out under your shop's name.
        </p>
      </div>

      <div className="divide-y divide-stone-200 border-y border-stone-200">
        {STEPS.map((step) => (
          <div
            key={step.num}
            data-testid={`how-step-${step.num}`}
            className="py-8 grid sm:grid-cols-12 gap-6 items-start"
          >
            <div className="sm:col-span-1 text-xs font-mono-ui text-stone-400 pt-1">
              {step.num}
            </div>
            <div className="sm:col-span-4 font-bold text-stone-900 text-lg font-serif-display">
              {step.title}
            </div>
            <div className="sm:col-span-5 text-sm text-stone-600 leading-relaxed">
              {step.body}
            </div>
            <div className="sm:col-span-2 text-xs font-mono-ui text-stone-500">
              <span className="block uppercase tracking-wider text-stone-400 mb-1">
                Your effort
              </span>
              <strong className="text-stone-800">{step.effort}</strong>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
